export const queryKeys = {
  BOOKED_FLAT_LIST: 'BOOKED_FLAT_LIST',
  ORDER_CANCEL_REASON: 'ORDER_CANCEL_REASON',
  ORDER_CANCEL_REASON_ID: 'ORDER_CANCEL_REASON_ID'
};
